import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function GVEPInstitutionalStoves() {
  return (
    <div className="art-page">
      <SEO
        title="Testing of Institutional Improved Cookstoves — GVEP International CARE Project — CIRCODU"
        description="CIRCODU assessed 13 schools with improved institutional stoves against 13 control schools using traditional equipment, conducting kitchen surveys and fuel consumption measurements to quantify institutional stove impacts."
        keywords="institutional cookstoves, GVEP International, CARE Project, kitchen survey, fuel consumption, emissions testing, school stoves, clean cooking, carbon offset, Uganda, CIRCODU, institutional stove testing Uganda, GVEP International CARE project Uganda, kitchen survey Uganda, fuel consumption measurement Uganda, emissions testing Uganda, school stoves Uganda, clean cooking solutions Uganda"
        url="/Testing-of-Institutional-Improved-Cookstoves-GVEP-International-CARE-Project"
        datePublished="2014-04-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Testing of Institutional Improved Cookstoves — GVEP International
              CARE Project
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              April 01, 2014
            </div>
            <h1 className="art-title">
              Testing of Institutional Improved Cookstoves — GVEP International
              CARE Project
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In early 2014, CIRCODU conducted field-based performance
                assessments of improved institutional cookstoves installed in
                schools across Central Uganda, under the{" "}
                <strong>
                  Capital Access for Renewable Energy Enterprises (CARE)
                </strong>{" "}
                project implemented by <strong>GVEP International</strong>. GVEP
                — the Global Village Energy Partnership — was an international
                organisation focused on expanding energy access and enterprise
                development in the developing world.
              </p>
              <p>
                Institutional cookstoves for schools, hospitals, and prisons
                represent some of the highest-impact opportunities in Uganda's
                clean cooking sector. A single school stove can affect hundreds
                of students and staff daily, making them a compelling target for
                clean energy investment.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                CIRCODU assessed <strong>13 project schools</strong> where
                improved institutional stoves had been installed, alongside{" "}
                <strong>13 baseline control schools</strong>
                still using traditional cooking equipment. The paired
                project-and-control design gave the assessment strong causal
                validity, enabling clear before-and-after comparisons. In each
                school, CIRCODU conducted:
              </p>
              <ol>
                <li>
                  <strong>Kitchen surveys</strong> to document cooking practices
                  and fuel use patterns.
                </li>
                <li>
                  <strong>Kitchen Performance Tests (KPTs)</strong> to measure
                  actual fuel consumption quantitatively.
                </li>
                <li>
                  <strong>Stove usage surveys</strong> to assess how
                  consistently kitchen staff used the new stoves.
                </li>
                <li>
                  <strong>Emission tests</strong> in 8 project and 12 control
                  schools, providing direct measurement of the air quality
                  improvements resulting from improved stove adoption.
                </li>
              </ol>
              <h2 className="art-subheading">Significance</h2>
              <p>
                CIRCODU's work provided GVEP and its partners with credible
                evidence of whether the CARE project's stove installations were
                genuinely delivering on their promised fuel and emissions
                benefits — evidence essential for performance reporting, carbon
                verification, and the case for scaling institutional cookstove
                investment across Uganda's public service facilities.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's institutional cookstove
                testing services, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
